var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoralTitle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 13,
    viewBox: "0 0 60 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5362 11.1467C10.2313 12.4105 8.54636 13 6.72035 13C2.01032 13 0.0197248 9.80972 0.000132358 6.56935C-0.0194601 3.31357 2.13571 0 6.72035 0C8.44056 0 10.0707 0.639597 11.3755 1.90723L9.78069 3.42146C8.94605 2.62004 7.82536 2.24629 6.72035 2.24629C3.66 2.24629 2.33947 4.48874 2.35515 6.57321C2.37474 8.63841 3.58555 10.7922 6.72035 10.7922C7.82536 10.7922 9.07536 10.3453 9.90608 9.52845L11.5362 11.1467Z",
    fill: "#383C42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6122 6.55394C24.5769 9.77504 22.5667 13 18.1114 13C13.6561 13 11.591 9.84825 11.591 6.57321C11.591 3.29431 13.7266 0 18.1114 0C22.4727 0 24.6474 3.29431 24.6122 6.55394ZM13.946 6.60788C14.0009 8.65382 15.1216 10.8462 18.1114 10.8462C21.1012 10.8462 22.2219 8.63841 22.2572 6.59247C22.2924 4.49259 21.0973 2.14226 18.1114 2.14226C15.1216 2.13841 13.8912 4.50415 13.946 6.60788Z",
    fill: "#383C42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6835 12.7149H36.5283V12.5531L32.6882 8.29935C35.0981 7.81772 35.8935 6.09158 35.8935 4.38085C35.8935 2.22703 34.3183 0.265856 31.3285 0.250444C30.3234 0.250444 29.3183 0.245628 28.3132 0.240811C27.3081 0.235995 26.303 0.231179 25.2979 0.231179V12.7149H27.6882V8.54979H29.9883L33.6835 12.7149ZM27.6882 6.42679V2.43509H31.3285C32.8332 2.43509 33.5032 3.43302 33.5032 4.43094C33.5032 5.42887 32.8488 6.42679 31.3285 6.42679H27.6882Z",
    fill: "#383C42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8692 10.3646H40.243L39.1537 12.7149H36.5636L42.2493 0.250445H44.8551L50.5448 12.7149H47.939L46.8692 10.3646ZM43.5542 2.86663L41.1991 8.1722H45.9092L43.5542 2.86663Z",
    fill: "#383C42"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4796 10.5418V0.250445H51.0894V12.7149H60V10.5418H53.4796Z",
    fill: "#383C42"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoralTitle);
export default __webpack_public_path__ + "static/media/coralTitle.7ae26fbb.svg";
export { ForwardRef as ReactComponent };